import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { GraduationCap, Award } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import SectionLabel from '../components/SectionLabel';

const Teaching = () => {
  const { t } = useTranslation();
  const courses = t('teaching.courses', { returnObjects: true });
  const qualifications = t('teaching.qualifications', { returnObjects: true });

  return (
    <div>
      <PageHeader eyebrow="Kalle Glauch" title={t('teaching.title')} lead={t('teaching.lead')} />

      <div className="mx-auto max-w-5xl px-6 py-14 md:px-10 md:py-16">
        <SectionLabel icon={GraduationCap}>{t('teaching.coursesLabel')}</SectionLabel>
        <motion.div
          className="mt-5 overflow-hidden rounded-md border border-line bg-beige-50"
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          {Array.isArray(courses) &&
            courses.map((course, index) => (
              <div
                key={index}
                className="flex flex-col gap-1 border-b border-line px-6 py-4 last:border-0 sm:flex-row sm:gap-6"
              >
                <div className="w-full flex-shrink-0 text-sm font-medium text-navy-600 sm:w-44">{course.period}</div>
                <div>
                  <div className="text-sm font-semibold leading-snug text-ink-900">{course.title}</div>
                  <div className="mt-0.5 text-sm text-ink-600">{course.institution}</div>
                  {course.description && <div className="mt-1 text-sm leading-relaxed text-ink-600">{course.description}</div>}
                </div>
              </div>
            ))}
        </motion.div>

        {Array.isArray(qualifications) && qualifications.length > 0 && (
          <div className="mt-14">
            <SectionLabel icon={Award}>{t('teaching.qualificationsLabel')}</SectionLabel>
            <div className="mt-5 overflow-hidden rounded-md border border-line bg-beige-50">
              {qualifications.map((q, index) => (
                <div key={index} className="border-b border-line px-6 py-4 text-sm leading-relaxed text-ink-900 last:border-0">
                  {q}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Teaching;
